module.exports = __webpack_public_path__ + "img/jucai8.eb1682f2.jpg";